import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/province`;

export const ACTION_TYPES = {
  FETCH_PROVINCE_LIST: 'province/FETCH_PROVINCE_LIST',
  UPDATE_PROVINCE: 'banner/UPDATE_PROVINCE',
  FETCH_PROVINCE: 'banner/FETCH_PROVINCE',
  RESET: 'province/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}
};

// REDUCER
const provinceReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROVINCE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROVINCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.UPDATE_PROVINCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROVINCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROVINCE):
    case FAILURE(ACTION_TYPES.UPDATE_PROVINCE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROVINCE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROVINCE):
        return {
          ...state,
          loading: false,
          entity: action.payload.data,
        };
    case SUCCESS(ACTION_TYPES.UPDATE_PROVINCE):
        return {
          ...state,
          updating: false,
          updateSuccess: true,
          entity: action.payload.data,
        };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default provinceReducer;

// ACTIONS
export const getEntities = () => ({
  type: ACTION_TYPES.FETCH_PROVINCE_LIST,
  payload: axios.get(apiUrl),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_PROVINCE,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_POST,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROVINCE,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
